<template>
  <div :class="$attrs.class">
    <label
      v-if="label"
      class="form-label"
      :for="id">{{ label }}:</label>
    <VueNumberFormat
      :id="id"
      ref="input"
      :value="modelValue"
      class="form-input text-right"
      v-bind="{ ...$attrs, class: null }"
      :options="numberOptions"
      @update:value="emitValue"
      :disabled="disabled" />
    <div v-if="error" class="form-error whitespace-normal">
      {{ error }}
    </div>
  </div>
</template>

<script lang="js">
import VueNumberFormat from 'vue-number-format'

export default {
    components: {
        VueNumberFormat,
    },
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default () {
                return `text-input-${self.crypto.randomUUID()}`
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [Number, String],
            default: 0,
        },
        max: {
            type: Number,
            default: null,
        },
        error: String,
        label: String,
        inputClass: String,
    },
    emits: ['update:modelValue'],
    computed: {
        numberOptions () {
            return { precision: 2, prefix: '', suffix: '', decimal: ',', thousand: '.', acceptNegative: false, isInteger: false }
        },
    },
    methods: {
        focus () {
            this.$refs.input.focus()
        },
        select () {
            this.$refs.input.select()
        },
        setSelectionRange (start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
        emitValue (val) {
            // overflow is blocked and the display reverts to the last valid
            // model value (maxlength semantics). Programmatic parent sets > max are
            // NOT corrected here — backend validation owns that boundary.
            if (this.max !== null && Number(val) > this.max) {
                this.revertDisplay()
                return
            }
            this.$emit('update:modelValue', val)
        },
        revertDisplay () {
            const [int, dec] = Number(this.modelValue ?? 0).toFixed(this.numberOptions.precision).split('.')
            const grouped = int.replace(/(\d)(?=(?:\d{3})+\b)/g, '$1.')
            this.$refs.input.$el.value = `${grouped},${dec}`
        },
    },
}
</script>
